import React, { useState, useEffect, useCallback } from 'react';
import './StatusTab.css';
import './HealthHourTab.css';
import { EcgWave } from './HealthCards';

function EcgTab({ svc }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [ecgExpanded, setEcgExpanded] = useState({});
  const [ecgWaves, setEcgWaves] = useState({});
  const [ecgLoading, setEcgLoading] = useState({});

  const toggleEcg = async (item) => {
    const aberto = !!ecgExpanded[item.id];
    setEcgExpanded((prev) => ({ ...prev, [item.id]: !aberto }));
    if (!aberto && !ecgWaves[item.id]) {
      setEcgLoading((prev) => ({ ...prev, [item.id]: true }));
      try {
        const d = await svc.getEcgWaveform(item.id);
        if (!d.error) setEcgWaves((prev) => ({ ...prev, [item.id]: d.values || [] }));
      } catch (e) { /* silêncio */ } finally {
        setEcgLoading((prev) => ({ ...prev, [item.id]: false }));
      }
    }
  };

  const load = useCallback(async () => {
    setLoading(true); setError(null);
    try {
      const d = await svc.getHealthAll();
      if (d.error) throw new Error(d.error);
      setData(d);
    } catch (e) { setError(e.message); } finally { setLoading(false); }
  }, [svc]);

  useEffect(() => { load(); }, [load]);

  if (loading && !data) return <div className="st-view"><p className="st-msg">Carregando ECG…</p></div>;

  return (
    <div className="st-view">
      <div className="st-head">
        <span className="st-updated">{data?.ecg_ultima_atualizacao ? `Última atualização · ${data.ecg_ultima_atualizacao}` : ''}</span>
        <button className="analise-refresh" onClick={load} disabled={loading}>{loading ? '…' : 'Atualizar'}</button>
      </div>
      {error && <p className="st-msg st-err">{error}</p>}

      {data?.ecg?.length > 0 ? (
        <div className="st-card">
          <h3 className="st-title">🫀 ECG</h3>
          <div className="hh-ecg-list">
            {data.ecg.map((e) => {
              const aberto = !!ecgExpanded[e.id];
              return (
                <div className="hh-ecg-wrap" key={e.id}>
                  <button className="hh-ecg-item" onClick={() => toggleEcg(e)}>
                    <span className="hh-ecg-date">{e.date_display} · {e.time_display}</span>
                    <span className="hh-ecg-classification" style={{ color: e.color }}>
                      {e.classification}
                    </span>
                    {e.avg_heart_rate != null && (
                      <span className="hh-ecg-hr">{e.avg_heart_rate} bpm</span>
                    )}
                    <span className="hh-ecg-chevron">{aberto ? '▲' : '▼'}</span>
                  </button>
                  {aberto && (
                    <div className="hh-ecg-chart-box">
                      {ecgLoading[e.id] && <p className="hh-ecg-msg">Carregando traçado…</p>}
                      {!ecgLoading[e.id] && ecgWaves[e.id]?.length > 0 && (
                        <EcgWave values={ecgWaves[e.id]} color={e.color} />
                      )}
                      {!ecgLoading[e.id] && ecgWaves[e.id]?.length === 0 && (
                        <p className="hh-ecg-msg">Onda não disponível pra essa leitura.</p>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      ) : (
        !loading && <p className="st-msg">Sem leituras de ECG ainda.</p>
      )}

      <div className="st-spacer" />
    </div>
  );
}

export default EcgTab;
